import { render, staticRenderFns } from "./AkibaHalisiPlan.vue?vue&type=template&id=d9b88a6c&scoped=true"
import script from "./AkibaHalisiPlan.vue?vue&type=script&lang=js"
export * from "./AkibaHalisiPlan.vue?vue&type=script&lang=js"
import style0 from "./AkibaHalisiPlan.vue?vue&type=style&index=0&id=d9b88a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b88a6c",
  null
  
)

export default component.exports